import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllContactsResponse, IContact } from "../models/Contact";

export default function useContacts(includeEbay: boolean = false, hideAuto: boolean = true) {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const contacts = useQuery({
    queryKey: ["contacts", { includeEbay, hideAuto }],
    queryFn: () => get<IAllContactsResponse>("/contact" + (includeEbay ? "?includeEbay=true" : "?includeEbay=false") + (hideAuto ? "&hideAuto=true" : "&hideAuto=false")),
    staleTime: 1000 * 60 * 10, // 10 minutes
  });

  const update = useMutation(
    (contact: IContact) => put(`/contact/${contact.id}`, contact),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["contacts"]);
        queryClient.invalidateQueries(["accounts"]);
      },
    }
  );

  return {
    contacts,
    update,
  };
}
